import { QRCodeSVG } from 'qrcode.react';

const QrCode = ({
  value,
  accessibleTitle,
  'data-test': dataTest,
}: {
  value: string;
  accessibleTitle: string;
  'data-test'?: string;
}) => {
  if (value == null) {
    return null;
  }

  return <QRCodeSVG value={value} title={accessibleTitle} data-test={dataTest} includeMargin />;
};

export default QrCode;
